/* eslint complexity: 0 */
const workflow_status_by_id = {
  'wf-205': 'Activated',
  'wf-210': 'Blocked',
  'wf-118': 'Awaiting approval'
};

const workflow_status_class_map = {
  Overdue: 'bg-danger-subtle text-danger-emphasis',
  Blocked: 'bg-danger-subtle text-danger-emphasis',
  'Awaiting approval': 'bg-warning-subtle text-warning-emphasis',
  Active: 'bg-success-subtle text-success-emphasis',
  Activated: 'bg-success-subtle text-success-emphasis',
  'In progress': 'bg-warning-subtle text-warning-emphasis'
};

const workflow_stage_summary_map = {
  'wf-205': { current: 'Activation', badge: 'CURRENT STAGE Â· 6 OF 6', icon: 'bi-truck' },
  'wf-210': { current: 'Training', badge: 'CURRENT STAGE Â· 4 OF 5', icon: 'bi-people' },
  'wf-118': { current: 'Legal & compliance approval', badge: 'CURRENT STAGE Â· 3 OF 6', icon: 'bi-file-earmark-text' },
  'wf-201': { current: 'Document collection', badge: 'CURRENT STAGE Â· 2 OF 6', icon: 'bi-truck' },
  'wf-230': { current: 'Document refresh', badge: 'CURRENT STAGE Â· 2 OF 6', icon: 'bi-arrow-clockwise' }
};

const workflow_evidence_by_id = {
  'wf-205': [
    { title: 'Signed contract', subtitle: 'Required to progress past "Activation"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: 'Activation record', subtitle: 'Required to progress past "Activation"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' }
  ],
  'wf-210': [
    { title: 'Induction', subtitle: 'Required to progress past "Training"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: 'POPIA', subtitle: 'Required to progress past "Training"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: 'Security awareness', subtitle: 'Required to progress past "Training"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' }
  ],
  'wf-118': [
    { title: 'Legal sign-off', subtitle: 'Required to progress past "Legal & compliance approval"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' }
  ],
  'wf-201': [
    { title: 'Tax clearance', subtitle: 'Required to progress past "Document collection"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: 'BBBEE certificate', subtitle: 'Required to progress past "Document collection"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: 'Banking', subtitle: 'Required to progress past "Document collection"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: 'Insurance', subtitle: 'Required to progress past "Document collection"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' }
  ],
  'wf-230': [
    { title: 'Fresh tax clearance', subtitle: 'Required to progress past "Document refresh"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: 'Updated banking', subtitle: 'Required to progress past "Document refresh"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: 'Insurance renewal', subtitle: 'Required to progress past "Document refresh"', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' }
  ]
};

const workflow_approvals_by_id = {
  'wf-205': [
    { title: 'CFO (above R 500k)', subtitle: 'At stage "Approvals"', meta: '', badge: 'Approved', badge_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-person-check', icon_class: 'is-green' },
    { title: 'Accounting Officer', subtitle: 'At stage "Activation"', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' }
  ],
  'wf-210': [
    { title: 'IT Security (privileged)', subtitle: 'At stage "System access approval"', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' }
  ],
  'wf-118': [
    { title: 'Legal & Compliance', subtitle: 'At stage "Legal & compliance approval"', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' },
    { title: 'Board', subtitle: 'At stage "Board approval"', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' }
  ],
  'wf-230': [
    { title: 'SCM Manager', subtitle: 'At stage "Re-approval"', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' }
  ],
  'wf-201': [
    { title: 'SCM officer', subtitle: 'At stage "Document collection"', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' },
    { title: 'CFO (above R 500k)', subtitle: 'At stage "Approvals"', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' },
    { title: 'Accounting Officer', subtitle: 'At stage "Activation"', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' }
  ]
};

const workflow_timeline_by_id = {
  'wf-205': [
    { title: 'Application', subtitle: 'Applicant / SCM officer Â· 1 day', meta: '1 of 6', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Document collection', subtitle: 'SCM officer Â· 3 days', meta: '2 of 6', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Verification', subtitle: 'Compliance Â· 2 days', meta: '3 of 6', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Risk score', subtitle: 'Risk Â· 1 day', meta: '4 of 6', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Approvals', subtitle: 'Finance / CFO Â· 2 days Â· approval: CFO (above R 500k)', meta: '5 of 6', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Activation', subtitle: 'OnboardOS Â· 1 day Â· approval: Accounting Officer', meta: '6 of 6', icon: 'bi-people', icon_class: 'is-green', connected: false }
  ],
  'wf-210': [
    { title: 'Employee record', subtitle: 'HR officer Â· 1 day', meta: '1 of 5', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Documents', subtitle: 'HR officer Â· 2 days', meta: '2 of 5', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Declarations', subtitle: 'Compliance Â· 1 day', meta: '3 of 5', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Training', subtitle: 'L&D Â· 5 days', meta: '4 of 5', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'System access approval', subtitle: 'IT Security Â· 1 day Â· approval: IT Security (privileged)', meta: '5 of 5', icon: 'bi-people', icon_class: 'is-slate', connected: false }
  ],
  'wf-118': [
    { title: 'Draft', subtitle: 'Policy owner Â· 5 days', meta: '1 of 6', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Review', subtitle: 'Stakeholders Â· 5 days', meta: '2 of 6', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Legal & compliance approval', subtitle: 'Legal / Compliance Â· 3 days Â· approval: Legal & Compliance', meta: '3 of 6', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
    { title: 'Board approval', subtitle: 'Board Â· Next sitting Â· approval: Board', meta: '4 of 6', icon: 'bi-circle', icon_class: 'is-slate', connected: true },
    { title: 'Publication', subtitle: 'Compliance Â· 1 day', meta: '5 of 6', icon: 'bi-circle', icon_class: 'is-slate', connected: true },
    { title: 'Staff acknowledgement', subtitle: 'All staff Â· 30 days', meta: '6 of 6', icon: 'bi-circle', icon_class: 'is-slate', connected: false }
  ]
};

const workflow_audit_by_id = {
  'wf-205': [
    { title: 'Activated - handed off to Complyon supplier register', subtitle: 'OnboardOS', meta: '14 May', icon: 'bi-check-circle', icon_class: 'is-green', connected: true },
    { title: 'Application submitted', subtitle: 'P. Naidoo', meta: '08 May', icon: 'bi-check-circle', icon_class: 'is-green', connected: false }
  ],
  'wf-210': [
    { title: 'Training stage - cybersecurity outstanding, access blocked', subtitle: 'L&D', meta: '12 May', icon: 'bi-exclamation-circle', icon_class: 'is-orange', connected: true },
    { title: 'Documents verified', subtitle: 'HR', meta: '11 May', icon: 'bi-check-circle', icon_class: 'is-green', connected: true },
    { title: 'Record created', subtitle: 'T. Reddy', meta: '10 May', icon: 'bi-check-circle', icon_class: 'is-green', connected: false }
  ],
  'wf-118': [
    { title: 'In legal & compliance review', subtitle: 'Legal', meta: '12 May', icon: 'bi-check-circle', icon_class: 'is-green', connected: true },
    { title: 'Review comments incorporated', subtitle: 'Stakeholders', meta: '05 May', icon: 'bi-check-circle', icon_class: 'is-green', connected: true },
    { title: 'Draft prepared', subtitle: 'Compliance', meta: '01 May', icon: 'bi-check-circle', icon_class: 'is-green', connected: false }
  ]
};

const workflow_connects_to_by_id = {
  'wf-205': ['Onboarding handoff', 'Suppliers', 'Procurement', 'Risks', 'Evidence vault'],
  'wf-210': ['Onboarding handoff', 'Employees', 'Training', 'Conflicts', 'Evidence vault'],
  'wf-118': ['Policies', 'Audits', 'Evidence vault', 'Delegation of authority']
};

const workflow_escalation_by_id = {
  'wf-205': ['SCM officer', 'SCM Manager', 'CFO (above R 500k)', 'Accounting Officer'],
  'wf-201': ['SCM officer', 'SCM Manager', 'CFO (above R 500k)', 'Accounting Officer'],
  'wf-210': ['HR officer', 'HR Manager', 'IT Security (privileged access)', 'COO'],
  'wf-118': ['Policy owner', 'Legal & Compliance', 'EXCO', 'Board'],
  'wf-230': ['SCM officer', 'SCM Manager', 'CFO (payment hold)', 'Accounting Officer']
};

export function workflow_name_text(workflow) {
  const workflow_name = String(workflow?.name || '').toLowerCase();
  return workflow_name;
}

export function workflow_status_label_for(workflow) {
  if (workflow?.status?.label) return workflow.status.label;
  const mapped_status = Reflect.get(workflow_status_by_id, workflow?.id);
  if (mapped_status) return mapped_status;
  if (workflow?.risk?.label === 'Critical' || workflow?.id === 'wf-230' || workflow?.id === 'wf-620') return 'Overdue';
  if (workflow?.risk?.label === 'High' || workflow?.highlighted) return 'Blocked';
  return 'In progress';
}

export function workflow_status_class_for(status) {
  const status_class = Reflect.get(workflow_status_class_map, status) || workflow_status_class_map['In progress'];
  return status_class;
}

export function workflow_stage_summary_for(workflow, helpers) {
  const stage_summary = Reflect.get(workflow_stage_summary_map, workflow?.id);
  if (stage_summary) return stage_summary;
  return {
    current: helpers.current_stage(workflow),
    badge: `CURRENT STAGE Â· 1 OF ${helpers.stage_count(workflow) || 1}`,
    icon: 'bi-diagram-3'
  };
}

export function workflow_evidence_for(workflow) {
  const evidence_by_id = Reflect.get(workflow_evidence_by_id, workflow?.id);
  if (evidence_by_id) return evidence_by_id;
  const workflow_name = workflow_name_text(workflow);
  if (workflow_name.includes('supplier')) return workflow_evidence_by_id['wf-201'];
  if (workflow_name.includes('revalidation')) return workflow_evidence_by_id['wf-230'];
  return [{ title: 'Supporting evidence', subtitle: 'Attach files relevant to the current stage', badge: 'Vault', badge_class: 'bg-light text-secondary border', icon: 'bi-file-earmark-text', icon_class: 'is-green' }];
}

export function workflow_approvals_for(workflow) {
  const approvals = Reflect.get(workflow_approvals_by_id, workflow?.id);
  if (approvals) return approvals;
  return [{ title: 'Approver', subtitle: 'Awaiting review', meta: '', badge: 'Pending', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-check', icon_class: 'is-orange' }];
}

function stage_subtitle_for(index, stages, workflow) {
  if (index === 0) return 'Applicant / Owner';
  if (index === stages.length - 1) {
    return workflow?.type_code === 'ONBOARDS' ? 'OnboardOS Â· Completion' : 'Closure';
  }
  return 'Current workflow stage';
}

function stage_icon_for(index) {
  return index < 2 ? 'bi-check-lg' : 'bi-circle';
}

function stage_icon_class_for(index) {
  return index < 2 ? 'is-green' : 'is-slate';
}

export function workflow_timeline_for(workflow) {
  const timeline = Reflect.get(workflow_timeline_by_id, workflow?.id);
  if (timeline) return timeline;
  const stages = workflow?.stages || [];
  return stages.map((stage, index) => ({
    title: stage,
    subtitle: stage_subtitle_for(index, stages, workflow),
    meta: `${index + 1} of ${stages.length || 1}`,
    icon: stage_icon_for(index),
    icon_class: stage_icon_class_for(index),
    connected: index < stages.length - 1
  }));
}

export function workflow_audit_trail_for(workflow, helpers) {
  const audit_trail = Reflect.get(workflow_audit_by_id, workflow?.id);
  if (audit_trail) return audit_trail;
  const title = workflow?.name || 'Workflow';
  return [
    { title: `${title} started`, subtitle: 'System event', meta: 'Today Â· 08:00', icon: 'bi-activity', icon_class: 'is-green', connected: true },
    { title: `${helpers.current_stage(workflow)} completed`, subtitle: workflow?.owner || 'Owner', meta: 'Today Â· 09:30', icon: 'bi-check-circle-fill', icon_class: 'is-green', connected: true },
    { title: 'Next action queued', subtitle: helpers.status_label(workflow), meta: 'Now', icon: 'bi-clock-history', icon_class: 'is-orange', connected: false }
  ];
}

export function workflow_connects_to_for(workflow) {
  const direct_links = Reflect.get(workflow_connects_to_by_id, workflow?.id);
  if (direct_links) return direct_links;
  const workflow_name = workflow_name_text(workflow);
  if (workflow_name.includes('supplier') || workflow_name.includes('revalidation')) {
    return ['Suppliers', 'Procurement', 'Finance', 'Risks', 'Evidence vault', 'Onboarding handoff'];
  }
  if (workflow_name.includes('incident')) {
    return ['Incidents', 'Corrective actions', 'Risks', 'Data privacy'];
  }
  return ['Policies', 'Controls', 'Evidence vault'];
}

export function workflow_escalation_for(workflow) {
  const escalation_path = Reflect.get(workflow_escalation_by_id, workflow?.id);
  if (escalation_path) return escalation_path;
  const workflow_name = workflow_name_text(workflow);
  if (workflow_name.includes('incident')) return ['Owner', 'Risk', 'Compliance', 'Regulator'];
  return ['Owner', 'Manager', 'Compliance'];
}

export function workflow_stage_meta_for(workflow) {
  const stage_meta_map = {
    'wf-205': 'OnboardOS Â· 1 day Â· approval: Accounting Officer',
    'wf-210': 'L&D Â· 5 days',
    'wf-118': 'Legal / Compliance Â· 3 days Â· approval: Legal & Compliance'
  };
  const stage_meta = Reflect.get(stage_meta_map, workflow?.id);
  if (stage_meta) return stage_meta;
  if (workflow?.type_code === 'ONBOARDS') return 'SCM officer Â· 3 days';
  return `${workflow?.owner || 'Owner'} Â· ${workflow?.type || 'Workflow'}`;
}

export function workflow_default_details(workflow, current_stage, stage_count) {
  return [
    { label: 'Type', value: workflow?.type || workflow?.type_code || 'Workflow' },
    { label: 'Owner', value: workflow?.owner || 'Compliance' },
    { label: 'Policy', value: workflow?.policy || 'Linked policy' },
    { label: 'Control', value: workflow?.control || 'Linked control' },
    { label: 'Current stage', value: current_stage },
    { label: 'Stages', value: `${stage_count} total` }
  ];
}

export function workflow_governing_rule_items(workflow) {
  return [
    { title: workflow?.policy || 'Policy', subtitle: 'Linked policy', meta: '', badge: '', icon: 'bi-file-earmark-text', icon_class: 'is-green' },
    { title: workflow?.control || 'Control', subtitle: 'Linked control', meta: '', badge: '', icon: 'bi-shield-check', icon_class: 'is-green' }
  ];
}

export function workflow_default_footer_actions(workflow) {
  const onboard_actions = [
    { label: 'Delete', variant: 'outline-secondary', icon: 'bi-trash' },
    { label: 'Open in OnboardOS', variant: 'outline-secondary', icon: 'bi-box-arrow-up-right' },
    { label: 'Advance stage', variant: 'primary', icon: 'bi-arrow-right' }
  ];
  const complyon_actions = [
    { label: 'Delete', variant: 'outline-secondary', icon: 'bi-trash' },
    { label: 'Return', variant: 'outline-secondary', icon: 'bi-arrow-counterclockwise' },
    { label: 'Advance stage', variant: 'primary', icon: 'bi-arrow-right' }
  ];
  return workflow?.type_code === 'ONBOARDS' ? onboard_actions : complyon_actions;
}
